/*
 * cf-spigots-off.js — Click Fencing
 *
 * Pete, 2026-09-07: "on a flat top quote the calculator has added in core drilled
 * spigots. check all the calculators and make sure we dont add these in and
 * increase the price."
 *
 * WHAT WAS WRONG
 * --------------
 * flat-top.js and blade.js both inherit calculateSpigotCosts() from the glass
 * calculator. It counts regularPanels + hingePanels + rakedPanels across every
 * section, doubles it, prices it against shopifyData.products.spigot, and pushes
 * BOTH a state.quoteBreakdown line and a state.cartItems line.
 *
 * Measured 2026-09-07 on the live theme by calling it directly:
 *   flat top, 2 sections (6000 + 9000)  -> 16 spigots, $970.72
 *   blade,    1 section  (6000)         ->  6 spigots, $364.02
 *   perfmesh                            -> function does not exist, clean
 *   glass                               -> correct, glass panels sit on spigots
 *
 * Real customer quote CF-FLAT-45-afef360f (Luke, 7 Sept) went out with
 * "Spigots & Hardware — Spigot (core drill) × 22 — $1,334.74" on a $3,322 job.
 *
 * cf-no-spigots.js already strips the line AFTER the fact, out of
 * state.quoteBreakdown and state.cartItems, on updateQuoteSummary plus a
 * MutationObserver. That is why the Configure step usually looks right. It does
 * not help anything that reads the breakdown outside that cleanup — the review
 * step kit editor, the enquiry email, the CRM plan — so the charge survived into
 * all three.
 *
 * THE FIX
 * -------
 * Do not generate it. Override calculateSpigotCosts to return 0 and push nothing
 * on the three aluminium/mesh pages. cf-no-spigots.js stays installed as a
 * second line of defence for any line already in a restored fence.
 *
 * Glass is untouched: the page guard below never matches /pages/glass-fencing.
 */
(function () {
  "use strict";

  if (!/(blade-fence-calculator|flat-top-fence-calculator|perfmesh-fence)/.test(location.pathname)) return;

  var TRIES = 0, MAX_TRIES = 200;

  function inst() {
    return window.glassCalculator || window.glassFencingCalculator || null;
  }

  function isSpigot(txt) {
    return /spigot/i.test(String(txt || ""));
  }

  // Remove any spigot line that was already generated before this patch installed
  // (restored fence, or another patch calling the costing path early).
  function stripExisting(fc) {
    try {
      if (!fc || !fc.state) return 0;
      var removed = 0, i;

      var bd = fc.state.quoteBreakdown;
      if (Object.prototype.toString.call(bd) === "[object Array]") {
        for (i = bd.length - 1; i >= 0; i--) {
          if (bd[i] && (isSpigot(bd[i].item) || isSpigot(bd[i].category))) { bd.splice(i, 1); removed++; }
        }
      }

      var ci = fc.state.cartItems;
      if (Object.prototype.toString.call(ci) === "[object Array]") {
        for (i = ci.length - 1; i >= 0; i--) {
          if (ci[i] && isSpigot(ci[i].title || ci[i].name)) { ci.splice(i, 1); removed++; }
        }
      }

      return removed;
    } catch (e) { return 0; }
  }

  function install() {
    var fc = inst();
    if (!fc) return false;

    var P = Object.getPrototypeOf(fc);
    if (!P) return false;
    if (P.__cfSpigotsOff) return true;

    // perfmesh has no such method — nothing to override, and that is fine.
    if (typeof P.calculateSpigotCosts === "function") {
      P.__cfSpigotsOffOriginal = P.calculateSpigotCosts;
      P.calculateSpigotCosts = function () {
        // Aluminium and mesh fences are post-mounted. No spigots, no cost, no line.
        return 0;
      };
    }

    stripExisting(fc);

    P.__cfSpigotsOff = true;
    try { console.log("[cf-spigots-off] installed on " + location.pathname); } catch (e) {}
    return true;
  }

  function tryInstall() {
    var done = false;
    try { done = install(); } catch (e) {}
    if (!done && ++TRIES < MAX_TRIES) setTimeout(tryInstall, 100);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", tryInstall);
  } else {
    tryInstall();
  }
})();
